import React from 'react';
import { Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { AppSkinProps } from '../../../types/decisions';
import CustomTooltip from '../../CustomTooltip/CustomTooltip';
import SmartImageV2 from '../../image/SmartImage2';
import './AppInfo.scss';

type AppInfoProps = {
    icon: AppSkinProps['criteriaData']['icon'];
    name: AppSkinProps['criteriaData']['name'];
    description: AppSkinProps['criteriaData']['description'];
    hideDescription?: boolean;
}

const AppInfo = ({
    icon,
    name,
    description,
    hideDescription = true,
}: AppInfoProps) => (
    <div className="appInfo">
        <div className="appInfo_icon">
            <SmartImageV2
                src={icon}
                alt={name}
                containerWidth={128}
                containerHeight={72}
                fallbackBackground="transparent"
            />
        </div>
        <div className="appInfo_title">
            <h1 className="appInfo_title_name">
                {name}
                {hideDescription && description && description.trim().length > 0 && (
                    <CustomTooltip
                        arrow
                        className="appInfo_title_name_tooltip"
                        title={<Typography>{description}</Typography>}
                    >
                        <InfoOutlined fontSize="small"/>
                    </CustomTooltip>
                )}
            </h1>
            {!hideDescription && <div className="appInfo_title_description">{description}</div>}
        </div>
    </div>
);

export default AppInfo;